module.exports = __webpack_public_path__ + "img/avatar7.d329c088.png";